module.exports = __webpack_public_path__ + "assets/images/3d1cfb1d76949b56a133a5c729240d8e.png";